<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/bruno-giacosa')">Bruno Giacosa
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/cantina-roberto-voerzio')">Cantina Roberto
                        Voerzio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/conterno-fantino')">Conterno Fantino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/piedmont/g-d-vajra')">G. D. Vajra
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/gaja')">Gaja
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giacomo-conterno')">Giacomo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio')">Giuseppe
                        Mascarello e Figlio
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/massolino')">Massolino
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/poderi-aldo-conterno')">Poderi Aldo Conterno
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/roagna')">Roagna
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/tenuta-la-giustiniana')">Tenuta La
                        Giustiniana
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/piedmont/vigne-marina-coppi')">Vigne Marina Coppi
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/piedmont')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">G. D. Vajra</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Poiché gli investitori del vino guardano oltre Bordeaux e Borgogna per quel qualcosa di speciale, l'attenzione è
                        rivolta all'Italia, e in particolare alla regione Piemonte. Nascono vigneti finora segreti
                        per raccogliere slancio (per non parlare dei pollici di colonna) facendo brillare il 2019 del Piemonte.
                    </div>

                    <div class="howto-title2">Una trinità tradizionale</div>
                    <div class="howto-text">
                        GD Vajra è una di queste proprietà. Già noto agli investitori di vino italiani per il suo livello costantemente elevato
                        qualità di Nebbiolo, Dolcetto e Barbera, la tenuta è forse uno dei migliori esempi di come
                        un prodotto piemontese può avere un gusto quasi borgognone. Intenso, puro e finemente complesso
                        struttura, non è difficile vedere come viene fatto questo confronto!
                        <br><br>
                        La tenuta stessa risale agli anni '20 quando Giuseppe Vajra acquistò il terreno con la speranza
                        di sfruttarlo a fini commerciali. Tuttavia, la burocrazia italiana e una guerra mondiale entrarono in gioco
                        modo e fu solo negli anni '60 e con l'avvento della DOCG che il figlio Aldo di Giuseppe poté iniziare
                        coltivando i suoi 40 ettari. La prima produzione di G.D. Vajra risale al 1978. Aderendo alla tradizione,
                        Giuseppe invecchia il suo Barolo in botti (botte) per tre anni e mezzo prima dell'imbottigliamento, però
                        nuove tecniche sono state introdotte nel tempo, grazie al figlio di Giuseppe e alla terza generazione.
                        Vajra difende il suo approccio, affermando che "i vini tradizionali sono più eleganti, più delicati
                        profumi, più snelli, un po' difficili, ma che offrono più piacere a tavola." La terra di Vajra è
                        particolarmente adatto a questo modo di pensare: ricco di gesso con affioramenti rocciosi, uva
                        maturano più tardi rispetto ad altri cru, regalando vini profumati e particolarmente longevi.
                    </div>

                    <div class="howto-title2">Grande, bellissimo Barolo</div>
                    <div class="howto-text">
                        Tutti gli esperti investitori di vino sapranno già che il Barolo è la prossima grande novità, e questo è un
                        produttore che deve essere il tuo radar. Il Bricco delle Viole di Vajra è sicuramente il suo prodotto di punta;
                        ea giudicare dal 2014 (94/100), possiamo aspettarci cose meravigliose dalla tenuta.
                        Il fiore all'occhiello, tuttavia, è il 2010. Molto popolare negli Stati Uniti, il secondo trimestre del 2019 è stato di livello base
                        prezzi intorno ai 90 euro a bottiglia per l'annata, quasi il 30% in più in 24 mesi.
                    </div>

                    <div class="howto-title2">Fatti e annate notevoli</div>
                    <div class="howto-text">
                        <ul>
                            <li>Parti uguali ispirate alle vetrate della cantina e alla reazione al modernismo
                                Le bottiglie di Barolo sono etichettate in modo più tradizionale, le colorate Freisa Kye e Albe di Vajra
                                le etichette fungono da illustrazione controculturale del vino "hardcore tradizionale".
                                dentro.
                            </li>
                            <li>Nell'estate del 2015, Stephen Spurrier ha offerto la sua opinione che “... il singolo vigneto Bricco
                                delle Viole è, per me, il Lafite del Barolo”. Nell'articolo del The Somm Journal “The Great
                                Vini del Piemonte”. Il Vinous di Antonio Galloni ha assegnato all'annata 2014 96 punti, e le quotazioni sono in aumento del +14% nell'arco di un anno da maggio 2018.
                            </li>
                            <li>Bruce Sanderson di Wine Spectator ha notato l'annata 2015 per aver mostrato "un potenziale impressionante in termini di qualità e longevità" mentre Vinous di Antonio Galloni canta 95 punti di elogio per il Ravera 2015 di Vajra; “Il Barolo Ravera 2015 cattura tutto il
                                meglio che l'annata ha da offrire. Una singola bottiglia in genere fa guadagnare agli investitori € 60
                                (al lordo delle imposte) nei mesi precedenti al suo rilascio alla fine del 2019.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">G. D. Vajra</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Da Weininvestoren über Bordeaux und Burgund hinaus nach etwas Besonderem suchen, ist Aufmerksamkeit gefragt
                        auf Italien und insbesondere auf die Region Piemont ausgerichtet. Bisher geheime Weinberge entstehen
                        um an Schwung zu gewinnen (ganz zu schweigen von den Zentimetern), damit das Jahr 2019 im Piedmont glänzen wird.
                    </div>

                    <div class="howto-title2">Eine traditionelle Dreieinigkeit</div>
                    <div class="howto-text">
                        G.D. Vajra ist ein solcher Nachlass. Bei italienischen Weinanlegern bereits für seinen konstant hohen Wert bekannt
                        Qualität von Nebbiolo, Dolcetto und Barbera, das Weingut ist vielleicht eines der besten Beispiele dafür
                        Ein piemontesisches Produkt kann einen fast burgundischen Geschmack haben. Intensiv, rein und fein komplex im Duft
                        Struktur ist es nicht schwer zu erkennen, wie dieser Vergleich zustande kommt!
                        <br><br>
                        Das Anwesen selbst stammt aus den 1920er Jahren, als Giuseppe Vajra das Land mit der Hoffnung kaufte
                        es zu kommerziellen Zwecken auszunutzen. Doch die italienische Bürokratie und ein Weltkrieg kamen ins Spiel
                        Und erst in den 1960er Jahren und mit der Einführung von DOCG konnte Giuseppes Sohn Aldo damit beginnen
                        bewirtschaftet seine 40 Hektar. G.D. Vajras erste Produktion fand 1978 statt. Der Tradition treu,
                        Giuseppe reift seinen Barolo jedoch dreieinhalb Jahre lang in Botti (Fass), bevor er in Flaschen abgefüllt wird
                        Dank Giuseppes Sohn und der dritten Generation wurden im Laufe der Zeit neue Techniken eingeführt.
                        Vajra verteidigt seinen Ansatz und sagt, dass „traditionelle Weine eleganter und delikater sind.“
                        Parfüms, schlanker, etwas schwieriger, aber mit mehr Freude bei Tisch.“ Vajras Land ist
                        für diese Denkweise besonders gut geeignet: kalkreich mit Felsvorsprüngen, Weintrauben
                        reifen später als andere Crus und ergeben duftende und besonders langlebige Weine.
                    </div>

                    <div class="howto-title2">Großer, schöner Barolo</div>
                    <div class="howto-text">
                        Alle erfahrenen Weininvestoren werden bereits wissen, dass Barolo das nächste große Ding ist, und das ist ein
                        Hersteller, der Ihr Radar sein muss. Vajras Bricco del Viole ist sicherlich sein Flaggschiffprodukt;
                        und wenn man vom Jahr 2014 ausgehen kann (94/100), können wir vom Anwesen wunderbare Dinge erwarten.
                        Das Juwel in seiner Krone ist jedoch das Jahr 2010. Das zweite Quartal 2019 erfreute sich in den USA großer Beliebtheit und hatte Einstiegsniveau
                        Die Preise liegen für den Jahrgang bei etwa 90 € pro Flasche, was einem Anstieg von fast 30 % in 24 Monaten entspricht.
                    </div>

                    <div class="howto-title2">Bemerkenswerte Fakten und Jahrgänge</div>
                    <div class="howto-text">
                        <ul>
                            <li>Zu gleichen Teilen von den Buntglasfenstern des Kellers und der Reaktion auf die Moderne inspiriert
                                Barolo-Flaschen sind eher traditionell etikettiert, Vajras farbenfrohe Freisa Kye und Albe
                                Etiketten dienen als gegenkulturelle Illustration des „harten traditionellen“ Weins
                                innen.
                            </li>
                            <li>Im Sommer 2015 brachte Stephen Spurrier seine Ansicht zum Ausdruck, dass „… der Einzelweinberg Bricco
                                delle Viole ist für mich der Lafite des Barolo.“ Im Artikel des Somm Journals „The Great
                                Weine aus dem Piemont“. Antonio Galloni’s Vinous bewertete den Jahrgang 2014 mit 96 Punkten und die Preise steigen im Einjahreszeitraum seit Mai 2018 um rund 14 %.
                            </li>
                            <li>Bruce Sanderson von Wine Spectator bemerkte, dass der Jahrgang 2015 „beeindruckendes Potenzial in Bezug auf Qualität und Langlebigkeit“ zeige, während Antonio Gallonis Vinous 95 Punkte für Vajras Ravera 2015 lobte; „Der Barolo Ravera 2015 fängt alles ein
                                das Beste, was der Jahrgang zu bieten hat.“ Eine einzelne Flasche bringt Anlegern in der Regel 60 € zurück
                                (vor Steuern) in den Monaten vor seiner Veröffentlichung Ende 2019.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">G. D. Vajra</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Alors que les investisseurs viticoles regardent au-delà de Bordeaux et de la Bourgogne pour ce quelque chose de spécial, l'attention est
                        tournée vers l'Italie, et notamment la région du Piémont. Des vignobles jusque-là secrets commencent
                        pour prendre de l'élan (sans parler des pouces de colonne) faisant briller le temps du Piémont en 2019.
                    </div>

                    <div class="howto-title2">Une trinité traditionnelle</div>
                    <div class="howto-text">
                        G.D. Vajra est l'un de ces domaines. Déjà connu des investisseurs italiens en vin pour son prix toujours élevé
                        qualité de Nebbiolo, Dolcetto et Barbera, le domaine est peut-être l'un des meilleurs exemples de la façon dont
                        un produit piémontais peut avoir un goût presque bourguignon. Intense, pure et finement complexe en
                        structure, il n'est pas difficile de voir comment cette comparaison est faite !
                        <br><br>
                        Le domaine lui-même remonte aux années 1920 lorsque Giuseppe Vajra a acheté le terrain avec l'espoir
                        de l'exploiter à des fins commerciales. Cependant, la bureaucratie italienne et une guerre mondiale sont arrivées
                        et ce n'est que dans les années 1960 et l'avènement de DOCG que le fils de Giuseppe, Aldo, a pu commencer
                        cultive ses 40 hectares. La première production de G.D. Vajra remonte à 1978. Fidèle à la tradition,
                        Giuseppe vieillit son Barolo in botti (fût) pendant trois ans et demi avant la mise en bouteille, bien que
                        de nouvelles techniques ont été introduites au fil du temps, grâce au fils de Giuseppe et à la troisième génération.
                        Vajra défend sa démarche en affirmant que "les vins traditionnels sont plus élégants, avec des
                        parfums, plus maigres, un peu difficiles, mais offrant plus de plaisir à table." La terre de Vajra est
                        particulièrement bien adapté à ce mode de pensée : riche en craie avec des affleurements rocheux, des raisins
                        mûrissent plus tard que les autres crus, donnant des vins parfumés et particulièrement vivaces.
                    </div>

                    <div class="howto-title2">Grand et beau Barolo</div>
                    <div class="howto-text">
                        Tous les investisseurs avertis en vin savent déjà que Barolo est la prochaine grande chose, et c'est un
                        producteur qui doit être votre radar. Le Bricco del Viole de Vajra est sûrement son produit phare ;
                        et à en croire le 2014 (94/100), on peut s'attendre à de belles choses de la part du domaine.
                        Le joyau de sa couronne, cependant, est le 2010. Très populaire aux États-Unis, le Q2 2019 avait un niveau d'entrée
                        prix autour de 90 € la bouteille pour le millésime, en hausse de près de 30 % en 24 mois.
                    </div>

                    <div class="howto-title2">Faits marquants et millésimes</div>
                    <div class="howto-text">
                        <ul>
                            <li>Parties égales inspirées des vitraux de la cave et réaction au modernisme
                                Les bouteilles Barolo étant plus traditionnellement étiquetées, les Freisa Kye et Albe colorées de Vajra
                                les étiquettes servent d'illustration contre-culturelle du vin "hardcore traditional"
                                à l'intérieur.
                            </li>
                            <li>À l'été 2015, Stephen Spurrier a proposé son point de vue selon lequel "… le vignoble unique Bricco
                                delle Viole est pour moi le Lafite de Barolo. Dans l'article du Somm Journal "The Great
                                Vins du Piémont ». Les Vinous d'Antonio Galloni ont attribué 96 points au millésime 2014, et les prix grimpent à hauteur de +14% sur un an depuis mai 2018.
                            </li>
                            <li>Bruce Sanderson de Wine Spectator a noté que le millésime 2015 montrait "un potentiel impressionnant en termes de qualité et de longévité" tandis que Vinous d'Antonio Galloni chante 95 points d'éloges pour le Ravera 2015 de Vajra ; « Le Barolo Ravera 2015 capture tous les
                                ce que le millésime a de mieux à offrir. Une seule bouteille coûte généralement 60 € aux investisseurs
                                (avant impôt) dans les mois précédant sa sortie fin 2019.
                            </li>
                        </ul>
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">G. D. Vajra</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        As wine investors look beyond Bordeaux and Burgundy for that something special, attention is
                        being turned to Italy, and notably the Piemonte region. Hitherto secret vineyards are beginning
                        to gather momentum (not to mention column inches) making 2019 Piedmont’s time to shine.
                    </div>

                    <div class="howto-title2">A traditional trinity</div>
                    <div class="howto-text">
                        G.D. Vajra is one such estate. Known to Italian wine investors already for its consistently high
                        quality of Nebbiolo, Dolcetto and Barbera, the estate is perhaps one of the best examples of how
                        a Piedmontese product can be almost Burgundian in taste. Intense, pure and finely complex in
                        structure, it is not hard to see how this comparison is made!
                        <br><br>
                        The estate itself dates back to the 1920s when Giuseppe Vajra purchased the land with the hope
                        of exploiting it for commercial reasons. However, Italian bureaucracy and a world war got in the
                        way and it was not until the 1960s and the advent of DOCG that Giuseppe’s son Aldo could begin
                        farming his 40-hectares. G.D. Vajra’s first production was in 1978. Adhering to tradition,
                        Giuseppe ages his Barolo in botti (barrel) for three and a half years prior to bottling, though
                        new techniques have been introduced over time, thanks to Giuseppe’s son and third generation.
                        Vajra defends his approach, saying that "traditional wines are more elegant, with more delicate
                        perfumes, leaner, somewhat difficult, but offering more pleasure at the table." Vajra’s land is
                        particularly well-suited for this way of thinking: rich in chalk with rocky outcrops, grapes
                        ripen later than other crus, giving fragrant and particularly long-lived wines.
                    </div>

                    <div class="howto-title2">Big, beautiful Barolo</div>
                    <div class="howto-text">
                        All savvy wine investors will already be aware that Barolo is the next big thing, and this is a
                        producer that needs to be your radar. Vajra’s Bricco del Viole is surely his flagship product;
                        and if the 2014 is anything to go by (94/100), we can expect marvellous things from the estate.
                        The jewel in his crown, however, is the 2010. Vastly popular in the US, Q2 2019 had entry level
                        prices at around €90 per bottle for the vintage, up almost 30% in 24-months.
                    </div>

                    <div class="howto-title2">Notable facts and vintages</div>
                    <div class="howto-text">
                        <ul>
                            <li>Equal parts inspired by the cellar’s stained glass windows and reaction to modernist
                                Barolo bottles being more traditionally labelled, Vajra’s colourful Freisa Kye and Albe
                                labels serve as a counter-cultural illustration of the “hardcore traditional” wine
                                inside.
                            </li>
                            <li>In summer 2015, Stephen Spurrier offered his view that “… the single vineyard Bricco
                                delle Viole is, for me, the Lafite of Barolo.” In The Somm Journal article “The Great
                                Wines of Piedmont”. Antonio Galloni’s Vinous awarded the 2014 vintage 96 points, and prices are rising to the tune of +14% for the one year period since May 2018.
                            </li>
                            <li>Wine Spectator’s Bruce Sanderson noted the 2015 vintage for showing “impressive potential in terms of quality and longevity” while Antonio Galloni’s Vinous sings 95 points worth of praise for Vajra’s 2015 Ravera; “The 2015 Barolo Ravera captures all the
                                best the vintage has to offer.” A single bottle typically setting investors back €60
                                (before tax) in the months leading up to its release in late 2019.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GDVajra",
    head: {
        title: 'G. D. Vajra | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the world-renowned wines of G. D. Vajra, a top Piedmont wine producer known for their exceptional Nebbiolo and Barbera varietals. Experience the unique terroir and traditional winemaking methods of this iconic Italian winery.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
            items: [
                {report: 'Bruno Giacosa', src: '/wine-guide/italy/piedmont/bruno-giacosa'},
                {report: 'Cantina Roberto Voerzio', src: '/wine-guide/italy/piedmont/cantina-roberto-voerzio'},
                {report: 'Conterno Fantino', src: '/wine-guide/italy/piedmont/conterno-fantino'},
                {report: 'G. D. Vajra', src: '/wine-guide/italy/piedmont/g-d-vajra'},
                {report: 'Gaja', src: '/wine-guide/italy/piedmont/gaja'},
                {report: 'Giacomo Conterno', src: '/wine-guide/italy/piedmont/giacomo-conterno'},
                {
                    report: 'Giuseppe Mascarello e Figlio',
                    src: '/wine-guide/italy/piedmont/giuseppe-mascarello-e-figlio'
                },
                {report: 'Massolino', src: '/wine-guide/italy/piedmont/massolino'},
                {report: 'Poderi Aldo Conterno', src: '/wine-guide/italy/piedmont/poderi-aldo-conterno'},
                {report: 'Roagna', src: '/wine-guide/italy/piedmont/roagna'},
                {report: 'Tenuta La Giustiniana', src: '/wine-guide/italy/piedmont/tenuta-la-giustiniana'},
                {report: 'Vigne Marina Coppi', src: '/wine-guide/italy/piedmont/vigne-marina-coppi'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
